import { 
  Box,
  FormControlLabel,
  Checkbox,
  Typography
} from '@mui/material';
import { User, LevelOneApprover } from '../../services/Types';
import React, { useState } from 'react';
import { useProgramOfficeData } from '../../hooks/useProgramOfficeData';

interface ApproverCheckboxesProps {
  users: User[];
  selectedApprovers: LevelOneApprover[];
  approverLevel: number;
  onApproversChange?: (approvers: LevelOneApprover[]) => void;
}

export const ApproverCheckboxes: React.FC<ApproverCheckboxesProps> = ({
  users,
  selectedApprovers,
  approverLevel,
  onApproversChange
}) => {
  const [localError, setLocalError] = useState<string | null>(null);
  const { findLevelOneApproverByEmail } = useProgramOfficeData();
  const selectedApproverFound = selectedApprovers?.some(approver => 
    users.some(user => user.email === approver.email)
  );
  return (
    <>
      <Box sx={{
        maxHeight: '200px',
        minHeight: '42px',
        overflowY: 'auto',
        border: '1px solid #ccc',
        borderRadius: '8px',
        padding: '8px',
        backgroundColor: 'white',
        display: 'flex',
        flexDirection: 'column',
        gap: '2px'
      }}>
        {users.map((user) => {
          return (user.approverLevel === approverLevel &&
            <FormControlLabel
              key={user.id}
              control={
                <Checkbox
                  checked={approverLevel !==1 || selectedApprovers?.some(approver => approver.email === user.email)}
                  disabled={approverLevel !== 1 }
                  sx={{
                    padding: '0px 10px',
                    '& .MuiSvgIcon-root': {
                      fontSize: '1.2rem',
                      color: '#666'
                    }
                  }}
                  onChange={(e) => {
                    const currentApprovers = selectedApprovers || [];
                    if (e.target.checked) {
                      // the selected object is a User object, so convert it to a LevelOneApprover object
                      const approver = findLevelOneApproverByEmail(user.email);
                      if (approver) {
                        setLocalError(null);
                        onApproversChange?.([...currentApprovers, approver]);
                      } else {
                        setLocalError('Approver information not found');
                      }
                    } else {
                      setLocalError(null);
                      onApproversChange?.(currentApprovers.filter(
                        approver => approver.email !== user.email
                      ));
                    }
                  }}
                />
              }
              label={`${user.firstName} ${user.lastName}`}
            />
          );
        })}
      </Box>
      {!selectedApproverFound && selectedApprovers.length > 0 && <Typography sx={{ color: 'warning.main' }}>
        {selectedApprovers.map(approver => approver.name).join(', ')} assigned but not in this list.
      </Typography>}
      {localError && <Typography sx={{ color: 'warning.main' }}>{localError}</Typography>}
    </>
  );
}; 